(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));
  qsa('[data-dismiss-announcement]').forEach((button) => button.addEventListener('click', () => {
    const bar = button.closest('[data-announcement]');
    if (bar) bar.hidden = true;
  }));
  const searchPanel = qs('[data-search-panel]');
  qsa('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) {
      const input = qs('input[type="search"]', searchPanel);
      if (input) input.focus();
    }
  }));
  const mobileMenu = qs('[data-mobile-menu]');
  qsa('[data-mobile-toggle]').forEach((button) => button.addEventListener('click', () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
  }));
  qsa('[data-mobile-close]').forEach((button) => button.addEventListener('click', () => {
    if (mobileMenu) mobileMenu.hidden = true;
  }));
  qsa('[data-accordion-button]').forEach((button) => button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    const panel = button.parentElement.querySelector('[data-accordion-panel]');
    if (panel) panel.hidden = expanded;
  }));
  qsa('[data-quantity]').forEach((wrap) => {
    const input = qs('input', wrap);
    const minus = qs('[data-quantity-minus]', wrap);
    const plus = qs('[data-quantity-plus]', wrap);
    if (minus && input) minus.addEventListener('click', () => input.value = Math.max(1, Number(input.value || 1) - 1));
    if (plus && input) plus.addEventListener('click', () => input.value = Number(input.value || 1) + 1);
  });
  qsa('[data-product-gallery]').forEach((gallery) => {
    const main = qs('.product-gallery__image', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((thumb) => thumb.addEventListener('click', () => {
      if (!main) return;
      main.src = thumb.dataset.src;
      qsa('[data-gallery-thumb]', gallery).forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));
  });
  qsa('[data-carousel]').forEach((carousel) => {
    const track = qs('[data-carousel-track]', carousel);
    let index = 0;
    const move = (dir) => {
      const slides = qsa('.feature-slide', carousel);
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index + dir));
      track.style.transform = 'translateX(' + (-index * 52) + '%)';
    };
    const prev = qs('[data-carousel-prev]', carousel);
    const next = qs('[data-carousel-next]', carousel);
    if (prev) prev.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));
  });
  const drawer = qs('[data-cart-drawer]');
  qsa('[data-cart-open]').forEach((button) => button.addEventListener('click', () => {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
  }));
  qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
  }));
})();